import EnhancedNextImage from 'components/helpers/Atoms/EnhancedNextImage/EnhancedNextImage';
import clsx from 'clsx';
import styles from '../Card.module.scss';
import {
  ImageAspectRatio,
  AspectRatioClassMap,
  AspectRatioNumericMap,
} from 'components/helpers/Atoms/EnhancedNextImage/ImageCommon';

export type CardLabelAppearance = 'Fill' | 'Outline';
export type CardLabelColor = 'Type A' | 'Type B';

export function CardImage(props: {
  imageSrc: string;
  labelName?: string;
  labelAppearance?: CardLabelAppearance;
  labelColor?: CardLabelColor;
  showLabel?: boolean;
  gridAspectRatio: ImageAspectRatio;
  aspectRatio: ImageAspectRatio;
  forceWhiteBackground?: boolean;
  imageAltText?: string;
}) {
  const {
    imageSrc,
    labelName,
    labelAppearance = 'Fill',
    labelColor = 'Type A',
    showLabel,
    gridAspectRatio,
    aspectRatio,
    forceWhiteBackground,
    imageAltText,
  } = props;
  const gridAspectRatioNumber = AspectRatioNumericMap[gridAspectRatio];
  const aspectRatioNumber = AspectRatioNumericMap[aspectRatio];
  const cardIsTallerThanGrid = aspectRatioNumber > gridAspectRatioNumber;
  const altText = (imageAltText ?? '').trim();
  return (
    <div className={clsx(styles.cardImageWrapper, AspectRatioClassMap[gridAspectRatio])}>
      <CardImageLabel
        labelName={labelName}
        labelAppearance={labelAppearance}
        labelColor={labelColor}
        showLabel={showLabel}
      />
      {imageSrc && (
        <EnhancedNextImage
          src={imageSrc}
          alt={altText}
          role="presentation"
          width={600}
          height={450}
          className={clsx(
            styles.cardImage,
            AspectRatioClassMap[aspectRatio],
            forceWhiteBackground ? styles['cardImage--whiteBackground'] : '',
            cardIsTallerThanGrid ? styles['cardImage--vertical'] : ''
          )}
        />
      )}
    </div>
  );
}

function CardImageLabel(props: {
  labelName?: string;
  labelAppearance?: CardLabelAppearance;
  labelColor?: CardLabelColor;
  showLabel?: boolean;
}) {
  const { labelName, labelAppearance = 'Fill', labelColor = 'Type A', showLabel } = props;

  if (!labelName || showLabel === false) {
    return null;
  }

  const labelColorClassName = labelColor === 'Type B' ? 'colorB' : 'colorA';
  const labelAppearanceClassName = labelAppearance.toLowerCase();

  return (
    <div className={styles.cardLabelWrapper} aria-hidden="true">
      <div
        className={clsx(
          styles.cardLabel,
          styles[`cardLabel--${labelAppearanceClassName}`],
          styles[`cardLabel--${labelColorClassName}`]
        )}
      >
        {labelName}
      </div>
    </div>
  );
}
